<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'StorekeepersFreights'}" v-bind:class="{[settingsLinkActiveClass]: ['StorekeepersFreights', 'StorekeepersFreights'].indexOf(settingLink)+1}">
                <md-icon>view_stream</md-icon>
                <span>Грузы</span>
            </router-link>
        </li>
    </ul>
</template>
<script>
    export default {
        name: 'storekeepersstocks-main-menu',
        sort: 3,
        module: 'storekeepersstocks',
        data() {
            return {
                module: 'storekeepersstocks'
            }
        },
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }            
        }
    }
</script>



// WEBPACK FOOTER //
// MainMenu.vue?3ee36905